package features.auth

import features.auth.domain.User
import features.auth.domain.AuthRepository
import features.auth.data.FirebaseAuthRepository
import features.auth.ui.LoginPage
import org.w3c.dom.HTMLElement

/**
 * Auth Feature Entry Point
 * 
 * This is the main interface for all authentication-related functionality.
 * All auth operations should go through this object.
 */
object AuthFeature {
    private val repository: AuthRepository = FirebaseAuthRepository()
    
    /**
     * Render the login page
     */
    fun renderLoginPage(root: HTMLElement) {
        LoginPage.render(root)
    }
    
    /**
     * Sign in with Google
     */
    fun login() {
        repository.signInWithGoogle()
            .then { user ->
                console.log("✅ Login successful:", user.name)
                // Auth state change handler in Main.kt will handle navigation
            }
            .catch { error ->
                console.error("❌ Login failed:", error)
                js("alert('Login failed. Please try again.')")
            }
    }
    
    /**
     * Sign out
     */
    fun logout() {
        repository.signOut()
            .then {
                console.log("✅ Logout successful")
                
                // TODO: Update store and navigate
                // Store.dispatch(LogoutAction())
                // Router.navigateTo("login")
            }
            .catch { error ->
                console.error("❌ Logout failed:", error)
            }
    }
    
    /**
     * Get current authenticated user
     */
    fun getCurrentUser(): User? {
        return repository.getCurrentUser()
    }
    
    /**
     * Listen to auth state changes
     */
    fun onAuthStateChanged(callback: (User?) -> Unit) {
        repository.onAuthStateChanged(callback)
    }
}
